import { render } from "./TwoFactorAuth.vue?vue&type=template&id=2d6e5819&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"

import "./TwoFactorAuth.vue?vue&type=style&index=0&id=2d6e5819&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6e5819"]])

export default __exports__